module.exports = __webpack_public_path__ + "img/30.04f95232.png";